const translations = {
    fa: {
        insta_club: 'اینستا کلاب',
        first_name: 'نام',
        last_name: 'نام خانوادگی',
        password: 'رمز عبور',
        new_password: 'رمز عبور جدید',
        password_confirmation: 'تکرار رمز عبور',
        purchase_and_activation: 'خرید و فعالسازی',
        video_guide: 'ویدیو راهنما',
        subscription: 'اشتراک',
        more_details: 'جزئیات بیشتر',
        price: 'مبلغ',
        wallet: 'کیف پول',
        support: 'پشتیبانی',
        favorite: 'علاقمندی',
        copy: 'کپی',
        copied_successfully: 'با موفقیت کپی شد',
        yesterday: 'دیروز',
        tomorrow: 'فردا',
        algorithmic: 'الگوریتمی',
        posting: 'پست گذاری',
        story: 'استوری',
        details: 'جزئیات',
        program: 'برنامه',
        guide: 'راهنما',
        save_changes: 'ذخیره تغییرات',
        start_time: 'ساعت شروع',
        end_time: 'ساعت پایان',
        post_idea_with_intelligence: 'ایده پست',
        story_idea_with_intelligence: 'ایده استوری',
        idea_for_post: 'ایده برای پست',
        choose_payment_method: 'انتخاب روش پرداخت',
        online_payment: 'پرداخت آنلاین',
        pay_with_wallet: 'پرداخت با کیف پول',
        inventory: 'موجودی',
        discount_code: 'کد تخفیف',
        import: 'ثبت کد',
        register: 'ثبت',
        delete: 'حذف',
        invoice: 'صورتحساب پرداخت',
        order_amount: 'مبلغ سفارش',
        special_discount: 'تخفیف ویژه',
        registration_date: 'تاریخ ثبت',
        payment_date: 'تاریخ پرداخت',
        total_payment: 'جمع کل پرداخت',
        transfer_to_bank_portal: 'انتقال به درگاه بانکی ...',
        withdrawing_from_wallet: 'در حال برداشت از کیف پول ...',
        please_try_again: 'مشکلی پیش آمده دوباره تلاش کنید',
        wallet_recharge: 'شارژ کیف پول',
        payment_status: 'وضعیت پرداخت',
        payment_not_successful: 'پرداخت شما موفقیت آمیز نبوده است',
        payment_not_successful_description:
            'متاسفانه پرداخت شما با مشکل مواجه شد. لطفاً دوباره تلاش کنید یا با تیم پشتیبانی اینستا کلاب در ارتباط باشد.',
        dashboard: 'داشبورد',
        successful_payment: 'پرداخت شما با موفقیت انجام شد ',
        successful_payment_description:
            'با تشکر از اعتماد شما، تراکنش مورد نظر با موفقیت ثبت گردید. در صورت بروز هرگونه مشکل یا نیاز به پشتیبانی، می‌توانید با تیم پشتیبانی اینستا کلاب در ارتباط باشید.',
        tracking_code: 'کد پیگیری',
        cancel_subscription: 'لغو اشتراک',
        activation_reservation_subscription: 'فعال سازی اشتراک رزرو',
        confirmation: 'تایید',
        service_temporarily_unavailable: 'این سرویس موقتا در دسترس نمی‌باشد',

        get confirmation_new_password() {
            return `تایید ${this.new_password}`;
        },
        get new_password_description() {
            return `لطفا ${this.new_password} را وارد نمایید و اطمینان حاصل کنید که با ${this.password} قبلی مشابه نباشد.`;
        },
        get password_changed() {
            return `ویرایش ${this.password} انجام شد`;
        },
        get password_changed_description() {
            return `${this.password} شما با موفقیت ویرایش شد, اکنون شما میتوانید با ${this.new_password} وارد حساب کاربری اینستاکلاب خود  شوید`;
        },
        get special_subscription() {
            return `${this.subscription} ویژه`;
        },
        get buy_subscription() {
            return `خرید ${this.subscription}`;
        },
        get with_price() {
            return `با ${this.price}`;
        },
        get done_story() {
            return `${this.story}‌های امروز رو انجام دادم.`;
        },
        get done_posting() {
            return `برنامه ${this.posting} امروز رو انجام دادم.`;
        },
        get enter_discount_code() {
            return `${this.discount_code} را وارد کنید`;
        },
        get discount_code_hint() {
            return `برای دریافت تخفیف، کافی است ${this.discount_code} خود را وارد کنید و از تخفیف خود بهره‌مند شوید.`;
        },
        get back_to_dashboard() {
            return `بازگشت به ${this.dashboard}`;
        }
    }
};

type Translation = (typeof translations)['fa'];
type TranslationKey = keyof Translation;

export default function t<Key extends TranslationKey>(key: Key, text?: string): string {
    const base = translations['fa'][key];
    return text ? `${base} ${text}` : base;
}

